<!--<div id="top"></div>-->
<mat-toolbar class="header-box-shadow app-header-toolbar" [ngStyle]="estilo">
  <button mat-icon-button (click)="toggleSidenav()">
    <mat-icon class="white-icon">menu</mat-icon>
  </button>

  <div class="header-title">
    <span *ngIf="ambiente">{{ ambiente }}</span>
    <span *ngIf="ambiente && globalVariables.telaAtiva"> - </span>
    <span *ngIf="globalVariables.telaAtiva">{{ globalVariables.telaAtiva }}</span>
    <span *ngIf="globalVariables.telaDetalheAtiva"> - {{ globalVariables.telaDetalheAtiva }}</span>
  </div>

  <div class="header-actions">
    <button
      mat-button
      [matMenuTriggerFor]="locationMenu"
      class="location-selector"
      [attr.aria-label]="'Local atual: ' + descricaoLocal(localAtual)"
      [matTooltip]="descricaoLocal(localAtual)"
    >
      <mat-icon class="location-icon">location_on</mat-icon>
      <span class="location-text">
        <span class="location-caption">Local atual</span>
        <span class="location-name">
          {{
            alterandoLocal
              ? 'Alterando local...'
              : carregandoLocais
                ? 'Carregando locais...'
                : descricaoLocal(localAtual)
          }}
        </span>
      </span>
    </button>

    <mat-menu
      #locationMenu="matMenu"
      class="location-menu-panel"
      xPosition="before"
      [overlapTrigger]="false"
      (closed)="limpaFiltroLocal()"
    >
      <div class="location-menu-header" (click)="$event.stopPropagation()">
        <span>Trocar local</span>
      </div>

      <div
        *ngIf="!carregandoLocais && !erroLocais && locais.length > 0"
        class="location-search"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
      >
        <mat-icon>search</mat-icon>
        <input
          type="text"
          placeholder="Buscar local"
          aria-label="Buscar local"
          [value]="filtroLocal"
          (input)="atualizaFiltroLocal($event)"
        />
      </div>

      <div *ngIf="carregandoLocais" class="location-menu-state">
        <span class="location-loading"></span>
        Carregando locais...
      </div>

      <div *ngIf="erroLocais" class="location-menu-state location-menu-error">
        <mat-icon>error_outline</mat-icon>
        <span>Não foi possível carregar os locais.</span>
        <button mat-button type="button" (click)="carregaLocais()">Tentar novamente</button>
      </div>

      <div
        *ngIf="!carregandoLocais && !erroLocais && locais.length === 0"
        class="location-menu-state"
      >
        Nenhum local disponível para este usuário.
      </div>

      <ng-container *ngIf="!carregandoLocais && !erroLocais">
        <button
          *ngFor="let local of locaisFiltrados"
          mat-menu-item
          class="location-menu-item"
          [disabled]="alterandoLocal"
          [class.location-menu-item-selected]="local.localAtual"
          (click)="selecionaLocal(local)"
        >
          <span class="location-menu-item-content">
            <span class="location-menu-item-text">
              <span class="location-menu-item-name">{{ local.nomeLocal }}</span>
              <span class="location-menu-item-detail"
                >{{ local.nomeFilial }} · Local {{ local.codigoLocal }}</span
              >
            </span>
            <mat-icon *ngIf="local.localAtual" class="location-check">check</mat-icon>
          </span>
        </button>

        <div *ngIf="locais.length > 0 && locaisFiltrados.length === 0" class="location-menu-state">
          Nenhum local encontrado.
        </div>
      </ng-container>
    </mat-menu>

    <button mat-button [matMenuTriggerFor]="accountMenu" class="avatar-button">
      <span class="avatar-content">
        <img src="../../../../assets/img/avatar.png" class="avatar" />
        <span fxHide.lt-sm="true" style="color: white">{{ name }}</span>
      </span>
    </button>

    <mat-menu #accountMenu="matMenu" overlapTrigger="false" style="background-color: white">
      <button mat-menu-item [routerLink]="['/meu-usuario', userRowid]">
        <span>Meu perfil</span>
      </button>
      <button mat-raised-button color="exit" style="left: 24px" (click)="onLogout()">
        <span>Sair</span>
      </button>
    </mat-menu>
  </div>
  <!--<mat-icon class="ml-3" title="Logout" (click)="onLogout()">exit_to_app</mat-icon>-->
</mat-toolbar>
